<template>
  <section class="app-feed">
    <header class="mb-30">
      <h2 class="has-text-weight-bold">News Feed</h2>
      <div class="buttons is-right">
        <!--a class="button is-secondary is-outlined">
          <span class="icon icon-search"></span>
        </a-->
        <a class="button is-secondary is-outlined" v-if="hasRole('ueg')">
          <span class="icon icon-add" @click="createPost = true"></span>
        </a>
      </div>
    </header>
    <div class="feed-list">
      <div class="app-feed-item">
        <user-avatar
          class="avatar"
          name="Fernando Jorge"
          photo=""
        ></user-avatar>
        <div class="moment">
          <span>Just now</span>&nbsp;
          <button class="button is-text is-icon" v-if="hasRole('ueg')">
            <span class="icon icon-edit"></span>
          </button>
        </div>
        <div class="feed-item-title">Feed title</div>
        <div class="description">lorem blasasa asas as as as</div>
      </div>
    </div>

    <app-modal v-model="createPost" title="Create a Post" @close="closePopup">
      <validation-observer ref="formfeed">
        <feed-form v-model="post"></feed-form>
      </validation-observer>
      <div class="create-dialog-actions">
        <div class="button is-primary" @click="submitPost">Create</div>
      </div>
    </app-modal>
  </section>
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';
import FeedForm from '@/components/forms/FeedForm.vue';
import AppModal from '@/components/AppModal.vue';

export default {
  name: 'AppFeed',
  components: {
    UserAvatar,
    FeedForm,
    AppModal
  },
  data() {
    return {
      createPost: false,
      post: {}
    };
  },
  methods: {
    closePopup() {
      this.post = {};
    },
    editPost(item) {
      this.createPost = true;
      this.post = item;
    },
    submitPost() {}
  }
};
</script>

<style lang="scss">
.app-feed {
  max-width: 410px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .feed-list {
    padding: 16px;
    background: rgba($light-gray, 0.3);
  }

  .app-feed-item {
    position: relative;
    padding-left: 75px;
    padding-bottom: 20px;
    border-bottom: solid 1px $light-gray;
    font-size: 1.4rem;
    .avatar {
      position: absolute;
      top: 10px;
      left: 0;
    }
    .moment {
      text-align: right;
      color: $light-gray;
    }
    .feed-item-title {
      padding: 8px 0;
      color: $light-gray;
      font-size: 16px;
    }
    .content {
      color: #ffffff;
    }
  }
}
</style>
